import type { PromoTip as PromoTipData } from './header-data';

import Link from '@eliadmin/core/src/components/link';
import { CmsImage } from '@eliadmin/core/src/components/dlz/ui/cms-image';
import { Heading } from '@eliadmin/core/src/components/dlz/ui/heading';
import { Icon } from '@eliadmin/core/src/components/dlz/ui/icon';
import { cn } from '@eliadmin/core/src/utils/style-utils';

/**
 * Dark tip card of the catalogue drawer (60029:5990) and the search panel (60263:35244): photo,
 * Figma „Overlay“ gradient, overline + H4 + text on top, red link at the bottom. The link covers
 * the whole card.
 */
export function PromoTip({ tip, className }: { tip: PromoTipData; className?: string }) {
  return (
    <div
      className={cn(
        'relative isolate flex flex-col justify-between gap-6 overflow-hidden rounded-3xl bg-[#0F1012] p-6',
        className,
      )}
    >
      <CmsImage image={tip.image} decorative fallback={false} sizes="450px" className="-z-10" />
      <span
        aria-hidden="true"
        className="absolute inset-0 -z-10 bg-[linear-gradient(180deg,rgba(15,16,18,0.95)_0%,rgba(15,16,18,0.6)_40%,rgba(15,16,18,0.2)_70%,rgba(15,16,18,0.85)_100%)]"
      />
      <div className="flex flex-col gap-2">
        {tip.label ? (
          <p className="dlz-label text-[#D7191F]">
            <span className="dlz-trim block">{tip.label}</span>
          </p>
        ) : null}
        <Heading title={tip.title} size="h4" as="p" className="text-white max-lg:max-w-[241px]" />
        {tip.text ? <p className="dlz-body-m text-[#B9BDC3]">{tip.text}</p> : null}
      </div>
      {tip.link ? (
        <Link
          href={tip.link.href}
          prefetch={false}
          className="dlz-body-m-medium flex w-fit items-center gap-1 text-[#D7191F] after:absolute after:inset-0 after:rounded-3xl focus-visible:outline-none focus-visible:after:ring-2 focus-visible:after:ring-inset focus-visible:after:ring-white"
        >
          {tip.link.label}
          <Icon name="caret-right" size={20} />
        </Link>
      ) : null}
    </div>
  );
}
